import { render, staticRenderFns } from "./AddRepeatChecklist.vue?vue&type=template&id=36af5bd5"
import script from "./AddRepeatChecklist.vue?vue&type=script&lang=js"
export * from "./AddRepeatChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports